/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaWorkflowType = {
    Standard: 'Standard',
    FlightOnly: 'FlightOnly'
} as const;
export type TaWorkflowType = typeof TaWorkflowType[keyof typeof TaWorkflowType];

